<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-23 16:00:28
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-09-07 11:06:42
 * @name: 编辑处理方案
 * @Description: 编辑处理方案
 * @FilePath: \project\src\views\index\afterSale\updateDealScheme\updateDealScheme.vue
 * @Author: desktop
-->
<template>
  <div class="waitApproveSignDealScheme">
    <div class="container">
      <div class="head">
        <el-button size="mini" type="primary" @click="back">返回</el-button>
      </div>
      <div class="content">
        <div class="form">
          <div class="row">
            <font class="label">是否需要用户寄回</font>
            <div class="value">
              <el-radio-group v-model="need_send_back">
                <el-radio
                  :label="item.value"
                  v-for="item of need_send_backs"
                  :key="item.value"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div class="row" v-if="has_send_back_way">
            <font class="label">寄回方式</font>
            <div class="value">
              <el-radio-group v-model="send_back_way">
                <el-radio
                  :label="item.value"
                  v-for="item of send_back_ways"
                  :key="item.value"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div class="row">
            <font class="label">是否需要费用</font>
            <div class="value">
              <el-radio-group v-model="need_pay">
                <el-radio
                  :label="item.value"
                  v-for="item of need_pays"
                  :key="item.value"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div class="row" v-if="has_pay_user">
            <font class="label">费用收取对象</font>
            <div class="value">
              <el-radio-group v-model="pay_user">
                <el-radio
                  :label="item.value"
                  v-for="item of pay_users"
                  :key="item.value"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div class="row" v-if="has_fee">
            <div class="fee-sign">
              <font>费用</font>
              <font>总计：{{ totalFee }}元</font>
              <img src="@/assets/icon/sign.png" @click="feeSign" />
            </div>
          </div>
          <div class="row" v-if="has_qa">
            <font class="label">是否需要品质审批</font>
            <div class="value">
              <el-radio-group v-model="need_qa_check">
                <el-radio
                  :label="item.value"
                  v-for="item of need_qa_checks"
                  :key="item.value"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="row">
            <font class="label">处理方式</font>
            <div class="value">
              <el-radio-group v-model="resolve_way">
                <el-radio
                  :label="item.value"
                  v-for="item of resolve_ways"
                  :key="item.value"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div class="row">
            <font class="label">入库日期</font>
            <div class="value">
              <el-date-picker
                size="mini"
                v-model="put_in_time"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择入库日期"
                :editable="false"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="row">
            <font class="label">发货日期</font>
            <div class="value">
              <el-date-picker
                size="mini"
                v-model="send_out_time"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择发货日期"
                :editable="false"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="row flex-normal">
            <font class="label">解决措施</font>
            <div class="value">
              <el-input
                type="textarea"
                :row="2"
                style="width: 400px"
                placeholder="请输入解决措施"
                v-model="resolve_plan"
              ></el-input>
            </div>
          </div>
          <div class="row flex-normal" v-if="has_send_back_items">
            <font class="label">用户需寄回物品</font>
            <div class="value">
              <el-input
                type="textarea"
                :row="2"
                style="width: 400px"
                placeholder="请输入用户需寄回物品"
                v-model="send_back_items"
              ></el-input>
            </div>
          </div>
          <div class="row flex-normal" v-if="has_send_back_address">
            <font class="label">寄件地址</font>
            <div class="value">
              <div class="address-info">
                <div class="address-row">
                  <font class="address-label">收货人</font>
                  <input
                    class="input"
                    placeholder="名字"
                    v-model="send_back_address.name"
                  />
                </div>
                <div class="address-row">
                  <font class="address-label">手机号</font>
                  <input
                    class="input"
                    placeholder="手机号"
                    v-model="send_back_address.phone"
                  />
                </div>
                <div class="address-row">
                  <font class="address-label">选择地区</font>
                  <el-cascader
                    size="mini"
                    v-model="send_back_address.address"
                    :options="address_options"
                  ></el-cascader>
                </div>
                <div class="address-row">
                  <font class="address-label">详细地址</font>
                  <input
                    class="input"
                    placeholder="小区楼栋/乡村名称"
                    v-model="send_back_address.detail"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-button class="submit" size="mini" type="primary" @click="submit"
          >提交</el-button
        >
      </div>
    </div>
    <dialog-fee-sign
      ref="dialogFeeSign"
      :needSelect="[]"
      @feeSignConfirm="feeSignHandler"
    ></dialog-fee-sign>
  </div>
</template>
<script>
import {
  need_send_backs,
  send_back_ways,
  need_pays,
  pay_users,
  need_qa_checks,
  resolve_ways,
} from "@/config/issue.config.js";
import dialogFeeSign from "@/components/afterSale/dialog-fee-sign.vue";
import region from "@/libs/region";
import issueService from "@/module/issue/issue.service";
import { getEventBus } from "@/config/eventBus.config.js";
import { origin_fee } from "@/config/issue.config";
import { debounceation } from "@/utils/decorator";
import _ from "lodash";
const origin_need_send_back = 1;
const origin_send_back_way = 1;
const origin_need_pay = 1;
const origin_pay_user = 1;
const origin_need_qa_check = 1;
const origin_resolve_way = 1;
const origin_send_back_items = "";
export default {
  name: "indexUpdateDealScheme",
  components: {
    dialogFeeSign,
  },
  data() {
    return {
      issueService: new issueService(),
      issue_name: "", //处理方式
      need_send_backs, //是否需要用户寄回
      need_send_back: 1, //选择的是否需要寄回， 1 是 0 否
      send_back_ways, //寄回方式
      send_back_way: 1, //选择的寄回方式， 1 先补后退 2 先退后补
      need_pay: 1, //选择的是否需要费用 1是 0否 2暂不填写
      pay_users, //费用收取对象
      pay_user: 1, //选择的费用收取对象
      feeParams: {}, //费用信息
      need_qa_check: origin_need_qa_check, //选择的是否需要品质审批 0 否 1是
      resolve_way: 1, //选择的处理方式 1 补发/更换配件 2 上门服务 3 整琴退换 4 其他
      put_in_time: "", //入库日期
      send_out_time: "", //发货日期
      resolve_plan: "", //解决措施
      send_back_items: "", //寄回物品
      send_back_address: {
        name: "",
        phone: "",
        address: ["", "", ""],
        detail: "",
      }, //寄件地址
      default_address: {},
      address_options: [],
      loading: false,
    };
  },
  computed: {
    // 是否需要费用
    need_pays() {
      return need_pays;
    },
    // 费用总计
    totalFee() {
      let fees = this.feeParams;
      let totalFee = 0;
      for (let x of fees) {
        if (x.type === "fee") {
          totalFee = Number(totalFee) + Number(x.value);
        }
      }
      return totalFee;
    },
    //是否需要品质审批
    need_qa_checks() {
      if (Number(this.send_back_way) === 2) {
        return need_qa_checks.filter((x) => Number(x.value) === 1);
      } else {
        return need_qa_checks;
      }
    },
    resolve_ways() {
      if (this.need_send_back === 0 && this.need_pay === 0) {
        return resolve_ways;
      } else if (
        this.need_send_back === 1 &&
        this.send_back_way === 2 &&
        (this.need_pay === 1 || this.need_pay === 2)
      ) {
        return resolve_ways.filter((x) => x.value !== 4);
      } else if (this.need_send_back === 1 && this.send_back_way === 1) {
        return resolve_ways.filter((x) => x.value !== 2 && x.value !== 4);
      } else {
        return resolve_ways.filter((x) => x.value !== 4);
      }
    },
    has_send_back_way() {
      return this.need_send_back === 1;
    },
    // 存在费用收取对象
    has_pay_user() {
      return this.issue_name === "货损" && this.need_pay === 1;
    },
    has_fee() {
      return this.need_pay === 1 && this.pay_user === 1;
    },
    has_qa() {
      return this.need_send_back === 1 && this.send_back_way === 2;
    },
    has_doOrder() {
      return (
        this.send_back_way === 2 && (this.need_pay === 1 || this.need_pay === 2)
      );
    },
    has_send_back_items() {
      return this.need_send_back === 1;
    },
    has_send_back_address() {
      return this.need_send_back === 1;
    },
  },
  watch: {
    need_send_back: {
      handler(nv, ov) {
        if (this.loading) {
          return;
        }
        this.send_back_way = JSON.parse(JSON.stringify(origin_send_back_way));
        this.need_pay = JSON.parse(JSON.stringify(origin_need_pay));
        this.resolve_way = JSON.parse(JSON.stringify(origin_resolve_way));
        this.send_back_items = JSON.parse(
          JSON.stringify(origin_send_back_items)
        );
        this.send_back_address = this.default_address;
      },
      immediate: false,
      deep: true,
    },
    send_back_way: {
      handler(nv, ov) {
        if (this.loading) {
          return;
        }
        this.need_pay = JSON.parse(JSON.stringify(origin_need_pay));
        this.resolve_way = JSON.parse(JSON.stringify(origin_resolve_way));
      },
      immediate: false,
      deep: true,
    },
    need_pay: {
      handler(nv, ov) {
        if (this.loading) {
          return;
        }
        this.pay_user = JSON.parse(JSON.stringify(origin_pay_user));
        this.feeParams = JSON.parse(JSON.stringify(origin_fee));
        this.resolve_way = JSON.parse(JSON.stringify(origin_resolve_way));
      },
      immediate: false,
      deep: true,
    },
    pay_user: {
      handler(nv, ov) {
        if (this.loading) {
          return;
        }
        this.feeParams = JSON.parse(JSON.stringify(origin_fee));
        this.resolve_way = JSON.parse(JSON.stringify(origin_resolve_way));
      },
      immediate: false,
      deep: true,
    },
  },
  created() {
    const _region = _.cloneDeep(region);
    this.address_options = _region.map((x) => {
      x.value = x.name;
      x.label = x.name;
      x.children = x.children.map((y) => {
        y.value = y.name;
        y.label = y.name;
        y.children = y.children.map((z) => {
          return {
            value: z.name,
            label: z.name,
          };
        });
        return y;
      });
      return x;
    });
    this.need_send_back = JSON.parse(JSON.stringify(origin_need_send_back));
    this.send_back_way = JSON.parse(JSON.stringify(origin_send_back_way));
    this.need_pay = JSON.parse(JSON.stringify(origin_need_pay));
    this.pay_user = JSON.parse(JSON.stringify(origin_pay_user));
    this.resolve_way = JSON.parse(JSON.stringify(origin_resolve_way));
    this.send_back_items = JSON.parse(JSON.stringify(origin_send_back_items));
    this.feeParams = JSON.parse(JSON.stringify(origin_fee));
    this.getDefaultAddress();
    this.getDefaultSet();
    this.getDetail();
  },
  methods: {
    @debounceation(300)
    back() {
      this.$router.go(-1);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取详情
     */
    getDetail() {
      this.issueService
        .getVeifyQuality({
          issue_id: this.$route.query.issue_id,
          run_id: this.$route.query.run_id,
          run_process_id: this.$route.query.run_process_id,
        })
        .then((res) => {
          this.issue_name = res.data.issue_name;
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取默认地址
     */
    getDefaultAddress() {
      this.issueService.getDefaultAddress().then((res) => {
        this.default_address = {
          name: res.data[0].name,
          phone: res.data[0].phone,
          address: res.data[0].region.split(" "),
          detail: res.data[0].detail,
        };
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取原数据
     */
    getDefaultSet() {
      this.loading = true;
      this.issueService
        .getVeifyQuality({
          issue_id: this.$route.query.issue_id,
          run_id: this.$route.query.run_id,
          run_process_id: this.$route.query.run_process_id,
        })
        .then((res) => {
          let {
            need_send_back,
            send_back_way,
            need_pay,
            resolve_way,
            put_in_time,
            send_out_time,
            resolve_plan,
            send_back_items,
            send_back_address,
            pay_user,
          } = res.data.plan;
          let fee = res.data.fee;
          this.need_send_back = need_send_back;
          this.send_back_way = send_back_way;
          this.need_pay = need_pay;
          this.pay_user = pay_user;
          this.resolve_way = resolve_way;
          this.put_in_time = put_in_time.slice(0, 10);
          this.send_out_time = send_out_time.slice(0, 10);
          this.resolve_plan = resolve_plan;
          this.send_back_items = send_back_items;
          let feeParams = JSON.parse(JSON.stringify(origin_fee));
          feeParams[feeParams.findIndex((x) => x.key === "shell_fee")].value =
            Number(fee?.parts_fee?.["shell_fee"] ?? "");
          feeParams[feeParams.findIndex((x) => x.key === "code_fee")].value =
            Number(fee?.parts_fee?.["code_fee"] ?? "");
          feeParams[
            feeParams.findIndex((x) => x.key === "prellmechanik_fee")
          ].value = Number(fee?.parts_fee?.["prellmechanik_fee"] ?? "");
          feeParams[
            feeParams.findIndex((x) => x.key === "keyboard_fee")
          ].value = Number(fee?.parts_fee?.["keyboard_fee"] ?? "");
          feeParams[feeParams.findIndex((x) => x.key === "hardware")].value =
            Number(fee?.parts_fee?.["hardware"] ?? "");
          feeParams[feeParams.findIndex((x) => x.key === "hammer")].value =
            Number(fee?.parts_fee?.["hammer"] ?? "");
          feeParams[feeParams.findIndex((x) => x.key === "other")].value =
            Number(fee?.parts_fee?.["other_fee"] ?? "");
          feeParams[
            feeParams.findIndex((x) => x.key === "parts_remark")
          ].value = fee?.parts_fee?.["parts_remark"] ?? "";
          feeParams[
            feeParams.findIndex((x) => x.key === "by_the_piece_fee")
          ].value = Number(fee?.salary?.["by_the_piece_fee"] ?? "");
          feeParams[
            feeParams.findIndex((x) => x.key === "hourly_wages")
          ].value = Number(fee?.salary?.["hourly_wages"] ?? "");
          feeParams[feeParams.findIndex((x) => x.key === "oil_paint")].value =
            Number(fee?.salary?.["oil_paint"] ?? "");
          feeParams[
            feeParams.findIndex((x) => x.key === "salary_remark")
          ].value = fee?.salary?.["salary_remark"] ?? "";
          feeParams[
            feeParams.findIndex((x) => x.key === "amount_returned_by_customer")
          ].value = Number(
            fee?.trans_port?.["amount_returned_by_customer"] ?? ""
          );
          feeParams[
            feeParams.findIndex((x) => x.key === "return_customer_amount")
          ].value = Number(fee?.trans_port?.["return_customer_amount"] ?? "");
          feeParams[
            feeParams.findIndex((x) => x.key === "transport_remark")
          ].value = fee?.trans_port?.["transport_remark"] ?? "";
          feeParams[
            feeParams.findIndex((x) => x.key === "management_expenses")
          ].value = Number(fee?.others?.["management_expenses"] ?? "");
          feeParams[feeParams.findIndex((x) => x.key === "tax")].value = Number(
            fee?.others?.["tax"] ?? ""
          );
          feeParams[feeParams.findIndex((x) => x.key === "others_fee")].value =
            Number(fee?.others?.["others_fee"] ?? "");
          feeParams[
            feeParams.findIndex((x) => x.key === "others_remark")
          ].value = fee?.others?.["remark"] ?? "";
          this.feeParams = feeParams;
          let { name, phone, address, detail } = send_back_address || {};
          this.send_back_address = {
            name: name || "",
            phone: phone || "",
            address: address ? address.split(" ") : ["", "", ""],
            detail: detail || "",
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击费用填写
     */
    @debounceation(300)
    feeSign() {
      this.$refs.dialogFeeSign.open(this.feeParams);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 费用填写弹窗回调
     */
    feeSignHandler(obj) {
      this.feeParams = obj?.fee ?? JSON.parse(JSON.stringify(origin_fee));
    },
    @debounceation(300)
    submit() {
      let fee = {};
      let params = {};
      params.run_process_id = this.$route.query.run_process_id;
      params.issue_id = this.$route.query.issue_id;
      params.need_send_back = this.need_send_back;
      this.has_send_back_way && (params.send_back_way = this.send_back_way);
      params.need_pay = this.need_pay;
      this.has_pay_user && (params.pay_user = this.pay_user);
      this.has_qa && (params.need_qa_check = this.need_qa_check);
      params.resolve_way = this.resolve_way;
      params.resolve_plan = this.resolve_plan;
      this.has_send_back_items &&
        (params.send_back_items = this.send_back_items);
      if (this.has_send_back_address) {
        params.send_back_address = JSON.parse(
          JSON.stringify(this.send_back_address)
        );
        params.send_back_address.address =
          params.send_back_address.address.join(" ");
      }
      if (this.has_fee) {
        for (let x of this.feeParams) {
          fee[x.key] = x.value;
        }
        params = {
          ...params,
          ...fee,
        };
      }
      params.put_in_time =
        new Date(this.put_in_time.replace(/-/g, "/")).getTime() / 1000;
      params.send_out_time =
        new Date(this.send_out_time.replace(/-/g, "/")).getTime() / 1000;
      this.issueService.editDealScheme(params).then((res) => {
        this.$EventBus.$emit(getEventBus("我的售后列表发生变更"));
        this.$EventBus.$emit(getEventBus("待审批列表发生变更"));
        this.$router.go(-1);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.waitApproveSignDealScheme {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .container {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    @extend .et-flex-column-normal;
    .head {
      margin-bottom: 10px;
      @extend .et-flex-start;
    }
    .content {
      width: 100%;
      box-sizing: border-box;
      @extend .et-flex-column-center;
      .form {
        width: 100%;
        box-sizing: border-box;
        padding: 15px 30px;
        box-shadow: $Vars-boxShadow-normal;
        border-radius: $Vars-border-radius-normal;
        .row {
          width: 100%;
          margin: 10px 0;
          padding: 10px 0;
          @extend .et-flex-start;
          font-size: $Vars-font-content-size;
          &.flex-normal {
            align-items: flex-start !important;
          }
          .label {
            flex-shrink: 0;
            width: calc(#{$Vars-font-content-size} * 12);
            margin-right: 40px;
            text-align: right;
          }
          .value {
            flex: 1;
            @extend .et-flex-normal;
            .address-info {
              width: 100%;
              @extend .et-flex-column-normal;
              .address-row {
                width: 400px;
                padding: 10px 0;
                border-top: 1px solid $Vars-border-third-color;
                &:first-child {
                  border: 0 !important;
                }
                @extend .et-flex-start;
                .address-label {
                  width: calc(#{$Vars-font-content-size} * 4);
                  font-size: $Vars-font-content-size;
                  color: $Vars-font-important-color;
                  flex-shrink: 0;
                  margin-right: 20px;
                }
                .input {
                  flex: 1;
                  background: none;
                  outline: none;
                  border: none;
                  &.picker {
                    @extend .et-clickElement;
                  }
                }
                input::-webkit-input-placeholder,
                input:-moz-placeholder,
                input::-moz-placeholder,
                input:-ms-input-placeholder {
                  color: $Vars-font-placeholder-color;
                }
              }
            }
          }
          .fee-sign {
            margin-left: calc(#{$Vars-font-content-size} * 12 + 40px);
            width: 300px;
            height: 30px;
            box-sizing: border-box;
            padding: 10px;
            border-radius: $Vars-border-radius-normal;
            border: 1px solid $Vars-border-third-color;
            @extend .et-flex-start;
            font {
              font-size: $Vars-font-miniContent-size;
              &:nth-child(1) {
                margin-right: 10px;
                flex-shrink: 0;
              }
              &:nth-child(2) {
                flex: 1;
                text-align: right;
              }
            }
            img {
              width: 15px;
              height: 15px;
              margin-left: 10px;
              flex-shrink: 0;
              @extend .et-clickElement;
            }
          }
        }
      }
      .submit {
        margin: 20px auto;
      }
    }
  }
}
</style>